import React from 'react';
import styles from './PartialReadOnlyInput.module.scss';
import ValidationErrorLabel from '../../../../../common/ValidationErrorLabel/ValidationErrorLabel';

const CONTAINERSIZE = ['containerWidthSm', 'containerWidthLg'];
const INPUTSIZE = ['inputWidthSm', 'inputWidthLg'];
const LABELPOSITION = ['labelStart', 'labelCenter'];

function PartialReadOnlyInput({
  onChange,
  title,
  amount,
  unit,
  containerSize,
  inputSize,
  labelPosition,
  disabled,
  error = ''
}) {
  const checkContainerSize = CONTAINERSIZE.includes(containerSize) && containerSize;
  const checkInputSize = INPUTSIZE.includes(inputSize) && inputSize;
  const checkLabelPosition = LABELPOSITION.includes(labelPosition) && labelPosition;

  return (
    <form className={`${styles.form} ${styles[checkContainerSize]}`}>
      <label className={`${styles.label} ${styles[checkLabelPosition]}`}>{title}</label>
      <div className={styles.inputField}>
        <input
          className={`${styles.input} ${styles[checkInputSize]}`}
          type="text"
          value={amount}
          onChange={onChange}
          disabled={disabled}
        />
        <span className={`${styles.inputReadOnly} ${styles[checkInputSize]}`}>{unit}</span>
      </div>
      {!!error && <ValidationErrorLabel message={error} />}
    </form>
  );
}

export default PartialReadOnlyInput;
